/**
 * @owner @Appboy/sms
 */

import type { I18nT } from "@lib/dashboardI18n";
import sharedConstants from "@lib/shared_constants";

import type { RcsMessageState, RcsMessageType } from "../types";
import { getRcsSchema } from "./rcsSchema";
import type { RcsRichCardType } from "./rich_card";

/**
 * Casts an RCS message to the schema for its selected message type.
 *
 * @param rcsMessage - The current RCS message values.
 * @param type - The newly selected RCS message type.
 * @param richCardType - The newly selected rich card subtype, when applicable.
 * @param t - The RCS composer translation function.
 * @param isTwilioProvider - Whether the selected messaging service is Twilio.
 * @returns The schema-cast RCS message with inapplicable fields removed.
 */
export const castRcsMessageToType = (
  rcsMessage: RcsMessageState,
  type: RcsMessageType,
  richCardType: RcsRichCardType | undefined,
  t: I18nT<"rcs-composer">,
  isTwilioProvider?: boolean
): RcsMessageState => {
  const nextMessage = {
    ...rcsMessage,
    type,
    ...(type === sharedConstants.RCS.MESSAGE_TYPES.RICH_CARD &&
    (richCardType !== undefined || rcsMessage.rich_card_type === undefined)
      ? {
          rich_card_type: richCardType ?? sharedConstants.RCS.RICH_CARD_TYPES.MEDIA,
        }
      : {}),
  };

  return getRcsSchema(t, isTwilioProvider).cast(nextMessage, {
    assert: false,
    stripUnknown: true,
  });
};
